import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "password-forgot-form__title" }, [
  /*#__PURE__*/_createTextVNode(" Did you forget "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" your password? ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "password-forgot-form__description" }, [
  /*#__PURE__*/_createTextVNode(" We’ll send you a link where you’ll be able "),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createTextVNode(" to set a new password for your account. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Back to login")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_item = _resolveComponent("form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_form_element = _resolveComponent("form-element")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createBlock(_component_base_form, { class: "password-forgot-form" }, {
    header: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_form_element, _mergeProps({ errors: _ctx.errors, model: _ctx.model, loading: _ctx.loading }, { onSubmit: _ctx.onSubmit }), {
        buttons: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: { name: 'login' },
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_base_button, _mergeProps({
            secondary: "",
            type: "submit"
          }, { loading: _ctx.loading }), {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 16)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_form_item, {
            label: "E-mail",
            name: 'email',
            rules: [_ctx.required, _ctx.email]
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event)),
                class: "password-forgot-form__input",
                name: "email",
                type: "email",
                autocomplete: "login-email"
              }, null, 512), [
                [_vModelText, _ctx.model.email]
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 16, ["onSubmit"])
    ]),
    _: 1
  }))
}